import EventEmitter from 'wolfy87-eventemitter'

const ee = new EventEmitter()

export default ee
